// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"4aa8fd45","238":"18280d3e","823":"196418d3"}[chunkId] + ".chunk.js";
};